import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { shellIconButtonClass } from './shellIconButton';
import { cn } from '@/lib/utils';

interface RefreshButtonProps {
  className?: string;
}

/**
 * Reloads the page — the whole document, not a cache invalidation.
 *
 * Deliberately the blunt instrument: a clinic on a flaky connection, or one
 * sitting on a service-worker-cached build after a deploy, needs the escape
 * hatch that "pull to refresh" gives on a native app and that the installed PWA
 * (standalone display, no browser chrome) otherwise has no button for.
 */
export function RefreshButton({ className }: RefreshButtonProps) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={() => window.location.reload()}
      aria-label={t('common.refreshPage')}
      title={t('common.refreshPage')}
      className={cn(shellIconButtonClass, className)}
    >
      <Icon name="refresh" size={16} />
    </button>
  );
}
